export const BORN_IN = {
  currentMarriage: 'currentMarriage',
  notCurrentMarriage: 'notCurrentMarriage',
};

export const BORN_IN_MARRIAGE = {
  ofApplicant: 'ofApplicant',
  ofSpouse: 'ofSpouse',
};

export enum CHILD_ADDRESS {
  matchWithApplicant = 'matchWithApplicant',
  matchWithSpouse = 'matchWithSpouse',
  notMatchWithSpouse = 'notMatch',
}

export enum CHANGE_NAME {
  match = 'match',
  notMatch = 'notMatch',
}

export enum CONFIRMING_DOCUMENTS {
  courtDecision = 'COURT_DECISION',
  consent = 'AGREEMENT_WITH_PARENT',
  indirectly = 'INDIRECT_CONFIRMATION',
}
